<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('contentManagement.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('contentManagement.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <ts-button outline color="info" @click.prevent="addNew">
            {{
            $t('add_new')
            }}
          </ts-button>
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template v-slot="{ record }">
          <td>{{ record.content_type.content_type }}</td>
          <td>{{ $store.getters.limitStringShow(record.contents) }}</td>
          <td>{{ record.language.language_name }}</td>
          <td>
							<!-- v-model="record.inactive"  -->
            <a-switch size="small" 
              :checked="!record.inactive"
							:loading="record._deleting" 
							@change="changeStatus(record)"
						/>
          </td>
          <td class="text-center">
            <a
              href="#"
              v-tooltip="$t('edit')"
              class="text-primary mr-2"
              @click.prevent="edit(record)"
            >
              <i class="fas fa-edit"></i>
            </a>
            <!-- <a-popconfirm
              class="ts-cursor-pointer"
              placement="left"
              :ok-text="$t('yes')"
              :cancel-text="$t('no')"
              @confirm="deleteRecord(record)"
            >
              <template slot="title">
                <p>{{ $t('are_you_sure_to_delete') }}</p>
              </template>
              <i
                class="fas fa-circle-notch spin ml-2"
                v-if="record._deleting"
              ></i>
              <i class="fa fa-trash ml-2 text-red" v-else></i>
            </a-popconfirm>-->
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { debounce } from 'lodash'

export default {
  name: 'contentManagement',
  data() {
    return {
      languages: [],
      loading: false,
      visible: false
    }
  },
  created() {
    this.fetchLang()
    this.fetchData()
  },
  computed: {
    ...mapState('administrator/contentManagement', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.administrator.contentManagement.search
      },
      set(newValue) {
        this.$store.commit(
          'administrator/contentManagement/SET_SEARCH',
          newValue
        )
        this.$store.commit('administrator/contentManagement/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        { name: this.$t('contentManagement.contentType') },
        { name: this.$t('contentManagement.content') },
        { name: this.$t('language') },
        {
          name: this.$t('contentManagement.active'),
          style: 'text-align:center; width: 1px;'
        },
        { name: this.$t('actions'), style: 'text-align:center; width: 1px;' }
      ]
    }
  },
  methods: {
    ...mapActions('administrator/contentManagement', [
      'destroy',
      'getLang',
      'status'
    ]),
    addNew() {
      this.$router.push({ name: 'content-management-create' })
    },
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('administrator/contentManagement/fetch', { ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    edit(record) {
      this.$store.commit(
        'administrator/contentManagement/SET_EDIT_DATA',
        record
      )
      this.$router.push({
        name: 'content-management-edit',
        params: { id: record.id }
      })
    },
    fetchLang() {
      this.getLang()
        .then(response => {
          this.languages = response.data.map(el => ({
            value: el.lang_id,
            label: el.language_name
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    changeStatus(record) {
			record._deleting = true
      this.status({
        id: record.id,
        data: {
          inactive: record.inactive
        }
      })
        .then(response => {
          this.$toasted.success(response.message)
          record.inactive = !record.inactive
        })
        .catch(error => {
          record.inactive = record.inactive
          this.$toasted.error(error.message)
				})
				.finally(() => {
					record._deleting = false
				})
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500),
    langId: debounce(function(search) {
      this.fetchData()
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('administrator/contentManagement/RESET_STATE')
    next()
  }
}
</script>
